import React from 'react';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';

const team = [
  { 
    name: 'Ahmet Söylemez', 
    role: 'Kurucu & CEO', 
    img: 'https://media.licdn.com/dms/image/v2/C4D03AQHNnBNT2Cvfpw/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1641404656804?e=1755129600&v=beta&t=82HmC58i6Ayl_zQzvWySVtXx_TTrDbEuQsEUxlGRumg',
    bio: 'Enerji sektöründe 10 yılı aşkın liderlik ve girişimcilik deneyimine sahip.',
    social: {
      linkedin: 'https://www.linkedin.com/in/soylemez-elektrik-otomasyon/'
    }
  },
  { 
    name: 'Mustafa Ekici', 
    role: 'Technical Product Leader - IoT & Energy Software', 
    img: 'https://media.licdn.com/dms/image/v2/C4D03AQG8ry-QD47KBg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1652545210934?e=1755129600&v=beta&t=FS5WJnW-iuueoQ2CcDrC54YvNl-BMlP71mWEzJcTpd4',
    bio: 'Enerji yazılımları ve IoT projelerinde teknik liderlik yapmaktadır.',
    social: {
      linkedin: 'https://linkedin.com/in/mstfaekici'
    }
  },
  { 
    name: 'Mücahit Çetin', 
    role: 'React-Frontend Developer Software Developer', 
    img: 'https://media.licdn.com/dms/image/v2/D4D03AQFnyYXVxRn35g/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1704033227462?e=1755129600&v=beta&t=6tK0QyzLCLG7hjHqjxec04ZLMGNXps43nSx2Eu2IPQs',
    bio: 'Modern frontend teknolojileriyle kullanıcı dostu arayüzler geliştiriyor.',
    social: {
      linkedin: 'https://linkedin.com/in/mucahitcetin1'
    }
  },
  { 
    name: 'Dilara Sevim Polat', 
    role: 'Artificial Intelligence Developer', 
    img: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/default-avatar.png',
    bio: 'Yapay zeka ve veri bilimi alanında projeler geliştiriyor.',
    social: {
      linkedin: 'https://www.linkedin.com/in/dilara-sevim-polat-48a13919a/'
    }
  },
];


export default function Team() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[var(--color-primary)] mb-4">Ekibimiz</h2>
          <p className="text-lg text-[var(--color-black)] max-w-2xl mx-auto">
            Yenilikçi çözümler üreten, deneyimli ve tutkulu ekibimizle tanışın.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((person, i) => (
            <div 
              key={i} 
              className="group bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative mb-6">
                <img 
                  src={person.img} 
                  alt={person.name} 
                  className="w-full h-48 object-cover rounded-xl"
                />
                <div className="absolute inset-0 bg-[var(--color-primary)]/80 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4">
                  <a href={person.social.linkedin} target="_blank" className="text-white hover:text-[var(--color-secondary)] transition">
                    <FaLinkedin size={24} />
                  </a>
                  
                </div>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-semibold text-[var(--color-primary)] mb-1">{person.name}</h3>
                <p className="text-[var(--color-secondary)] font-medium mb-2">{person.role}</p>
                <p className="text-[var(--color-black)] text-sm">{person.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 